import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { heroMovies } from "@/mocks/movies";

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = heroMovies.length;

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const movie = heroMovies[current];
  const categoryLabels: Record<string, string> = {
    dianying: "电影",
    dianshiju: "电视剧",
    dongman: "动漫",
    zongyi: "综艺",
  };

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={movie.image}
          alt={movie.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 h-full max-w-[1400px] mx-auto px-4 md:px-6 flex items-end pb-10 md:pb-16">
        <div className="w-full flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-xl">
            <div className="flex items-center gap-2 mb-3 flex-wrap">
              <span className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                {categoryLabels[movie.category] || movie.category}
              </span>
              <span className="text-white/70 text-sm">{movie.year}</span>
              <span className="text-accent-400 text-sm flex items-center gap-1">
                <i className="ri-star-fill"></i> {movie.rating}
              </span>
            </div>
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 font-heading">
              {movie.title}
            </h2>
            <p className="text-white/70 text-sm line-clamp-2 mb-4 hidden md:block">
              {movie.description}
            </p>
            <Link
              to={`/movie/${movie.id}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              立即观看
            </Link>
          </div>

          <div className="flex items-center gap-2">
            {Array.from({ length: total }).map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`h-1.5 rounded-full transition-all cursor-pointer ${
                  i === current ? "w-8 bg-primary-500" : "w-4 bg-white/40 hover:bg-white/60"
                }`}
                aria-label={`第 ${i + 1} 张`}
              />
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/20 hover:bg-white/40 flex items-center justify-center cursor-pointer transition-colors z-20"
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-white text-lg"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/20 hover:bg-white/40 flex items-center justify-center cursor-pointer transition-colors z-20"
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-white text-lg"></i>
      </button>
    </section>
  );
}